import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useRecoilState, useRecoilValue } from "recoil";
import DropDown from "../../../../Filters/DropDown";
import { sunsetDetailButtonType } from "../SunsetDetailButtons";
import { ISunsetData } from "./SunsetDetailInfo";
import {
  sunsetDetailDataState,
  VerticalTableLabel,
  VerticalTableRow,
  VerticalTableValue,
} from "./SunsetSubs";

export default function SunsetType() {
  const location = useLocation() as unknown as ISunsetData;
  const buttonType = useRecoilValue(sunsetDetailButtonType);

  const [sunsetDetailData, setSunsetDetailData] = useRecoilState(
    sunsetDetailDataState
  );

  const [sunsetType, setSunsetType] = useState({
    // 일몰 타입
    value: location?.state ? `${location?.state?.sunsetData?.ssetType}` : "",
    label: location?.state
      ? location?.state?.sunsetData?.ssetType === 1
        ? "OPT-IN"
        : location?.state?.sunsetData?.ssetType === 2
        ? "OPT-OUT"
        : ""
      : "선택",
  });

  // 일몰 타입 리스트
  const sunsetTypeOption = [
    { value: "1", label: "OPT-IN" },
    { value: "2", label: "OPT-OUT" },
  ];

  useEffect(() => {
    if (sunsetType?.value !== "") {
      setSunsetDetailData({
        ...sunsetDetailData,
        sunsetType: +sunsetType?.value!,
      });
    }
  }, [sunsetType]);

  return (
    <VerticalTableRow>
      <VerticalTableLabel>일몰 타입</VerticalTableLabel>

      {buttonType === "view" ? (
        <VerticalTableValue>{sunsetType?.label}</VerticalTableValue>
      ) : (
        <DropDown
          optionList={sunsetTypeOption}
          dropdownValue={sunsetType}
          setDropDownValue={setSunsetType}
        />
      )}
    </VerticalTableRow>
  );
}
